"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARAGRAPH_TYPES = exports.DIRECTION = exports.DEVICE_TYPE = exports.DEFAULT_STYLE = void 0;
var DEFAULT_STYLE = {
  DEFAULT_FONT_SIZE: 'normal',
  DEFAULT_TEXT_COLOR: 'greyDark',
  DEFAULT_TITLE_TYPE: 'h2',
  DEFAULT_TITLE_COLOR: 'neutral',
  DEFAULT_MARGIN_BOTTOM: 'small'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var DEVICE_TYPE = {
  desktop: 'desktop',
  mobile: 'mobile',
  tablet: 'tablet'
};
exports.DEVICE_TYPE = DEVICE_TYPE;
var PARAGRAPH_TYPES = {
  LIST: 'list',
  BULLET: 'bullet',
  NORMAL: 'normal',
  ICON: 'icon'
};
exports.PARAGRAPH_TYPES = PARAGRAPH_TYPES;
var DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.DIRECTION = DIRECTION;